import { render, staticRenderFns } from "./AktifBolgeler.vue?vue&type=template&id=03183e57&scoped=true"
import script from "./AktifBolgeler.vue?vue&type=script&lang=js"
export * from "./AktifBolgeler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03183e57",
  null
  
)

export default component.exports